module.exports = __webpack_public_path__ + "img/title-image.640e5e32.png";